import { OdometerHourmeterReportMessages, TranslationOdometerHourmeterReportMessages } from "../interfaces/odometerHourmeterReportMessages";

const odometerHourmeterReportMessages: TranslationOdometerHourmeterReportMessages = {
  [OdometerHourmeterReportMessages.title]: "Total Odometer/Hourmeter Report",
  [OdometerHourmeterReportMessages.startDateTime]: "Start Period",
  [OdometerHourmeterReportMessages.endDateTime]: "End Period",
  [OdometerHourmeterReportMessages.date]: "Date",
  [OdometerHourmeterReportMessages.vehicleCode]: "Vehicle",
  [OdometerHourmeterReportMessages.vehicleDescription]: "Description",
  [OdometerHourmeterReportMessages.originalAllocation]: "Original Allocation",
  [OdometerHourmeterReportMessages.currentAllocation]: "Current Allocation",
  [OdometerHourmeterReportMessages.totalOdometer]: "Total Odometer (KM)",
  [OdometerHourmeterReportMessages.totalHourmeter]: "Total Hourmeter (Hours)",
  [OdometerHourmeterReportMessages.dailyOdometer]: "Daily Odometer (KM)",
  [OdometerHourmeterReportMessages.dailyHourmeter]: "Daily Hourmeter (Hours)",
  [OdometerHourmeterReportMessages.noDataFound]: "No data found for the given filters",
  [OdometerHourmeterReportMessages.invalidFilter]: "Invalid filter. Please provide at least one identification criteria",
  [OdometerHourmeterReportMessages.success]: "Report generated successfully",
  [OdometerHourmeterReportMessages.error]: "Error generating odometer/hourmeter report",
  [OdometerHourmeterReportMessages.invalidDateRange]: "Invalid date range. Maximum allowed: 30 days",
  [OdometerHourmeterReportMessages.fleet]: "Fleet",
  [OdometerHourmeterReportMessages.selectVehicle]: "Select vehicle",
  [OdometerHourmeterReportMessages.allVehicles]: "All vehicles"
};

export const messages = odometerHourmeterReportMessages;
